import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  ServicesAutocompleteQuery,
  ServicesAutocompleteResponse,
} from '@hud/portal-dtos/webapp-autocomplete.dto';
import { PORTAL_BASE } from '../consts';

export const SERVICES_AUTOCOMPLETE = 'services_autocomplete';

export default function useServicesAutocompleteQuery(
  query: ServicesAutocompleteQuery,
) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SERVICES_AUTOCOMPLETE, query],
    queryFn: async () => {
      const response = await client.get<ServicesAutocompleteResponse>(
        `${PORTAL_BASE}/autocomplete/services`,
        {
          params: query,
        },
      );
      return ServicesAutocompleteResponse.parse(response.data);
    },
    enabled: isReady,
    placeholderData: keepPreviousData,
  });
}
